   <div class="row top-buffer">
    <div class="col-md-8" *ngIf="(chartType == 'line')">
     <canvas baseChart
          [datasets]="chartDataSet"
          [labels]="chartLabelSet"
          [options]="chartOption"
          [legend]="chartLegend"
          [chartType]="lineType">
     </canvas>
   </div>
   <div class="col-md-12" *ngIf="(chartType == 'horizontalBar')">
    <div class="col-md-10 text-center">
      <ul class="legend">
        <li *ngFor="let legendItem of customizedLegends">
          <span (click)="processLegendTerm(legendItem.legend)" [ngStyle]="setLegendStyle(legendItem.legend.fillStyle)"></span>
          <p id="{{legendItem.legend.text}}" tooltip="{{legendItem.tooltip}}">{{legendItem.displayName}}</p>
          <button [disabled]="!legendItem.allowToSort" type="button" class="btn btn-secondary btn-sm fa fa-sort-asc asc-size" (click)="sortBy(legendItem.legend,'asc')"></button>
          <button [disabled]="!legendItem.allowToSort" type="button" class="btn btn-secondary btn-sm fa fa-sort-desc desc-size" (click)="sortBy(legendItem.legend,'desc')"></button>
        </li>
     </ul>
    </div>
    <div class="col-md-2 text-right">
      <a href="javascript:void(0);" (click) = setToDefault()><p class="text-muted">Standardansicht</p></a>
    </div>
    <div class="col-md-12" align="center">
      <canvas baseChart
          [datasets]="chartDataSet"
          [labels]="chartLabelSet"
          [options]="chartOption"
          [legend]="false"
          [colors]="chartBarColors"
          [chartType]="barHorizontalType"
          (chartHover)="chartHovered($event)">
     </canvas>
    </div>
   </div>
   <div class="col-md-7" *ngIf="(chartType == 'pie')">
      <canvas baseChart width="60" height="60"
          [data]="chartDataSet"
          [labels]="chartLabelSet"
          [chartType]="pieType"
          [colors]="chartPieColors"
          (chartHover)="chartHovered($event)">
      </canvas>
   </div>
  </div>